import type {MaterialsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/MaterialsNetwork';
import type {GeoObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/Geo';
import type {EventsNetworkSopNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/sop/EventsNetwork';
import type {PerspectiveCameraObjNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/obj/PerspectiveCamera';
import type {RootManagerNode} from './../../../../../@polygonjs/polygonjs/src/engine/nodes/manager/Root';
import type {ExampleData, DataCallbackOptions} from '../../Common';

export function createData(options: DataCallbackOptions): ExampleData {
	const {scene} = options;
	const root = scene.root();

	function create_geo1(parentNode: RootManagerNode) {
		var geo1 = parentNode.createNode('geo');
		geo1.setName('geo1');
		function create_MAT(geo1: GeoObjNode) {
			var MAT = geo1.createNode('materialsNetwork');
			MAT.setName('MAT');
			function create_lineBasic1(MAT: MaterialsNetworkSopNode) {
				var lineBasic1 = MAT.createNode('lineBasic');
				lineBasic1.setName('lineBasic1');
				lineBasic1.uiData.setPosition(0, -200);
				lineBasic1.params.postCreateSpareParams();
				lineBasic1.params.runOnSceneLoadHooks();
				return lineBasic1;
			}
			function create_lineBasic2(MAT: MaterialsNetworkSopNode) {
				var lineBasic2 = MAT.createNode('lineBasic');
				lineBasic2.setName('lineBasic2');
				lineBasic2.uiData.setPosition(0, -50);
				lineBasic2.p.color.set([0.1843137254901961, 0.8862745098039215, 0.09411764705882353]);
				lineBasic2.p.lineWidth.set(9.1);
				lineBasic2.params.postCreateSpareParams();
				lineBasic2.params.runOnSceneLoadHooks();
				return lineBasic2;
			}
			function create_lineBasic3(MAT: MaterialsNetworkSopNode) {
				var lineBasic3 = MAT.createNode('lineBasic');
				lineBasic3.setName('lineBasic3');
				lineBasic3.uiData.setPosition(0, 100);
				lineBasic3.p.color.set([0.6745098039215687, 0.09411764705882353, 0.8862745098039215]);
				lineBasic3.params.postCreateSpareParams();
				lineBasic3.params.runOnSceneLoadHooks();
				return lineBasic3;
			}
			function create_lineBasic4(MAT: MaterialsNetworkSopNode) {
				var lineBasic4 = MAT.createNode('lineBasic');
				lineBasic4.setName('lineBasic4');
				lineBasic4.uiData.setPosition(0, 250);
				lineBasic4.p.color.set([0.09411764705882353, 0.5411764705882353, 0.8862745098039215]);
				lineBasic4.params.postCreateSpareParams();
				lineBasic4.params.runOnSceneLoadHooks();
				return lineBasic4;
			}
			create_lineBasic1(MAT);
			create_lineBasic2(MAT);
			create_lineBasic3(MAT);
			create_lineBasic4(MAT);
			MAT.uiData.setPosition(-550, 400);
			MAT.params.postCreateSpareParams();
			MAT.params.runOnSceneLoadHooks();
			return MAT;
		}
		function create_boxLines1(geo1: GeoObjNode) {
			var boxLines1 = geo1.createNode('boxLines');
			boxLines1.setName('boxLines1');
			boxLines1.uiData.setPosition(600, 150);
			boxLines1.params.postCreateSpareParams();
			boxLines1.params.runOnSceneLoadHooks();
			return boxLines1;
		}
		function create_copy1(geo1: GeoObjNode) {
			var copy1 = geo1.createNode('copy');
			copy1.setName('copy1');
			copy1.uiData.setPosition(-100, 100);
			copy1.params.postCreateSpareParams();
			copy1.params.runOnSceneLoadHooks();
			return copy1;
		}
		function create_line1(geo1: GeoObjNode) {
			var line1 = geo1.createNode('line');
			line1.setName('line1');
			line1.uiData.setPosition(-150, -100);
			line1.p.direction.set([0, 0, 1]);
			line1.params.postCreateSpareParams();
			line1.params.runOnSceneLoadHooks();
			return line1;
		}
		function create_line2(geo1: GeoObjNode) {
			var line2 = geo1.createNode('line');
			line2.setName('line2');
			line2.uiData.setPosition(250, 200);
			line2.params.postCreateSpareParams();
			line2.params.runOnSceneLoadHooks();
			return line2;
		}
		function create_material1(geo1: GeoObjNode) {
			var material1 = geo1.createNode('material');
			material1.setName('material1');
			material1.uiData.setPosition(-100, 400);
			material1.p.material.set('../MAT/lineBasic2');
			material1.params.postCreateSpareParams();
			material1.params.runOnSceneLoadHooks();
			return material1;
		}
		function create_material2(geo1: GeoObjNode) {
			var material2 = geo1.createNode('material');
			material2.setName('material2');
			material2.uiData.setPosition(-350, 500);
			material2.p.material.set('../MAT/lineBasic1');
			material2.params.postCreateSpareParams();
			material2.params.runOnSceneLoadHooks();
			return material2;
		}
		function create_material3(geo1: GeoObjNode) {
			var material3 = geo1.createNode('material');
			material3.setName('material3');
			material3.uiData.setPosition(250, 500);
			material3.p.material.set('../MAT/lineBasic3');
			material3.params.postCreateSpareParams();
			material3.params.runOnSceneLoadHooks();
			return material3;
		}
		function create_material4(geo1: GeoObjNode) {
			var material4 = geo1.createNode('material');
			material4.setName('material4');
			material4.uiData.setPosition(600, 500);
			material4.p.material.set('../MAT/lineBasic4');
			material4.params.postCreateSpareParams();
			material4.params.runOnSceneLoadHooks();
			return material4;
		}
		function create_merge1(geo1: GeoObjNode) {
			var merge1 = geo1.createNode('merge');
			merge1.setName('merge1');
			merge1.uiData.setPosition(-100, 250);
			merge1.p.compact.set(true);
			merge1.params.postCreateSpareParams();
			merge1.params.runOnSceneLoadHooks();
			return merge1;
		}
		function create_merge2(geo1: GeoObjNode) {
			var merge2 = geo1.createNode('merge');
			merge2.setName('merge2');
			merge2.uiData.setPosition(0, 750);
			merge2.flags.display.set(true);
			merge2.params.postCreateSpareParams();
			merge2.params.runOnSceneLoadHooks();
			return merge2;
		}
		function create_sphere1(geo1: GeoObjNode) {
			var sphere1 = geo1.createNode('sphere');
			sphere1.setName('sphere1');
			sphere1.uiData.setPosition(50, -200);
			sphere1.p.resolution.set([11, 11]);
			sphere1.params.postCreateSpareParams();
			sphere1.params.runOnSceneLoadHooks();
			return sphere1;
		}
		function create_transform1(geo1: GeoObjNode) {
			var transform1 = geo1.createNode('transform');
			transform1.setName('transform1');
			transform1.uiData.setPosition(-350, 400);
			transform1.p.t.set([-4.293112615076389, 0, 0]);
			transform1.params.postCreateSpareParams();
			transform1.params.runOnSceneLoadHooks();
			return transform1;
		}
		function create_transform2(geo1: GeoObjNode) {
			var transform2 = geo1.createNode('transform');
			transform2.setName('transform2');
			transform2.uiData.setPosition(250, 400);
			transform2.p.t.set([3.218657629053822, 0.09837727969536059, 0]);
			transform2.params.postCreateSpareParams();
			transform2.params.runOnSceneLoadHooks();
			return transform2;
		}
		function create_transform3(geo1: GeoObjNode) {
			var transform3 = geo1.createNode('transform');
			transform3.setName('transform3');
			transform3.uiData.setPosition(600, 400);
			transform3.p.t.set([4.997843986033096, 0.7449294472598302, 0.21493401776097576]);
			transform3.params.postCreateSpareParams();
			transform3.params.runOnSceneLoadHooks();
			return transform3;
		}
		function create_transform4(geo1: GeoObjNode) {
			var transform4 = geo1.createNode('transform');
			transform4.setName('transform4');
			transform4.uiData.setPosition(50, -50);
			transform4.p.t.set([0, 2.029971653488763, 0]);
			transform4.params.postCreateSpareParams();
			transform4.params.runOnSceneLoadHooks();
			return transform4;
		}
		create_MAT(geo1);
		var boxLines1 = create_boxLines1(geo1);
		var copy1 = create_copy1(geo1);
		var line1 = create_line1(geo1);
		var line2 = create_line2(geo1);
		var material1 = create_material1(geo1);
		var material2 = create_material2(geo1);
		var material3 = create_material3(geo1);
		var material4 = create_material4(geo1);
		var merge1 = create_merge1(geo1);
		var merge2 = create_merge2(geo1);
		var sphere1 = create_sphere1(geo1);
		var transform1 = create_transform1(geo1);
		var transform2 = create_transform2(geo1);
		var transform3 = create_transform3(geo1);
		var transform4 = create_transform4(geo1);
		copy1.setInput(0, line1);
		copy1.setInput(1, transform4);
		material1.setInput(0, merge1);
		material2.setInput(0, transform1);
		material3.setInput(0, transform2);
		material4.setInput(0, transform3);
		merge1.setInput(0, copy1);
		merge2.setInput(0, material2);
		merge2.setInput(1, material1);
		merge2.setInput(2, material3);
		merge2.setInput(3, material4);
		transform1.setInput(0, merge1);
		transform2.setInput(0, line2);
		transform3.setInput(0, boxLines1);
		transform4.setInput(0, sphere1);
		geo1.uiData.setPosition(-50, -150);
		geo1.flags.display.set(true);
		geo1.params.postCreateSpareParams();
		geo1.params.runOnSceneLoadHooks();
		return geo1;
	}
	function create_perspectiveCamera1(parentNode: RootManagerNode) {
		var perspectiveCamera1 = parentNode.createNode('perspectiveCamera');
		perspectiveCamera1.setName('perspectiveCamera1');
		function create_events1(perspectiveCamera1: PerspectiveCameraObjNode) {
			var events1 = perspectiveCamera1.createNode('eventsNetwork');
			events1.setName('events1');
			function create_cameraOrbitControls1(events1: EventsNetworkSopNode) {
				var cameraOrbitControls1 = events1.createNode('cameraOrbitControls');
				cameraOrbitControls1.setName('cameraOrbitControls1');
				cameraOrbitControls1.uiData.setPosition(150, 50);
				cameraOrbitControls1.p.target.set([0.2051085277357888, 0.7848987977780493, -0.8027917218435165]);
				cameraOrbitControls1.params.postCreateSpareParams();
				cameraOrbitControls1.params.runOnSceneLoadHooks();
				return cameraOrbitControls1;
			}
			create_cameraOrbitControls1(events1);
			events1.uiData.setPosition(-200, 50);
			events1.params.postCreateSpareParams();
			events1.params.runOnSceneLoadHooks();
			return events1;
		}
		create_events1(perspectiveCamera1);
		perspectiveCamera1.uiData.setPosition(-200, 100);
		perspectiveCamera1.flags.display.set(true);
		perspectiveCamera1.p.t.set([4.986443793648478, 5.756830046905014, 8.615658208993]);
		perspectiveCamera1.p.r.set([-27.829246370503107, 24.177323729053203, 12.19984359304324]);
		perspectiveCamera1.p.s.set([0.9999999999999999, 0.9999999999999997, 0.9999999999999998]);
		perspectiveCamera1.p.controls.set('./events1/cameraOrbitControls1');
		perspectiveCamera1.params.postCreateSpareParams();
		perspectiveCamera1.params.runOnSceneLoadHooks();
		return perspectiveCamera1;
	}
	function create_geo2(parentNode: RootManagerNode) {
		var geo2 = parentNode.createNode('geo');
		geo2.setName('geo2');
		function create_MAT(geo2: GeoObjNode) {
			var MAT = geo2.createNode('materialsNetwork');
			MAT.setName('MAT');
			function create_meshStandard1(MAT: MaterialsNetworkSopNode) {
				var meshStandard1 = MAT.createNode('meshStandard');
				meshStandard1.setName('meshStandard1');
				meshStandard1.uiData.setPosition(0, 0);
				meshStandard1.params.postCreateSpareParams();
				meshStandard1.params.runOnSceneLoadHooks();
				return meshStandard1;
			}
			create_meshStandard1(MAT);
			MAT.uiData.setPosition(-150, 50);
			MAT.params.postCreateSpareParams();
			MAT.params.runOnSceneLoadHooks();
			return MAT;
		}
		function create_material1(geo2: GeoObjNode) {
			var material1 = geo2.createNode('material');
			material1.setName('material1');
			material1.uiData.setPosition(50, 50);
			material1.flags.display.set(true);
			material1.p.material.set('../MAT/meshStandard1');
			material1.params.postCreateSpareParams();
			material1.params.runOnSceneLoadHooks();
			return material1;
		}
		function create_plane1(geo2: GeoObjNode) {
			var plane1 = geo2.createNode('plane');
			plane1.setName('plane1');
			plane1.uiData.setPosition(50, -100);
			plane1.p.size.set([14, 14]);
			plane1.params.postCreateSpareParams();
			plane1.params.runOnSceneLoadHooks();
			return plane1;
		}
		create_MAT(geo2);
		var material1 = create_material1(geo2);
		var plane1 = create_plane1(geo2);
		material1.setInput(0, plane1);
		geo2.uiData.setPosition(-50, -250);
		geo2.flags.display.set(true);
		geo2.params.postCreateSpareParams();
		geo2.params.runOnSceneLoadHooks();
		return geo2;
	}
	function create_spotLight1(parentNode: RootManagerNode) {
		var spotLight1 = parentNode.createNode('spotLight');
		spotLight1.setName('spotLight1');
		spotLight1.uiData.setPosition(200, 150);
		spotLight1.flags.display.set(true);
		spotLight1.p.penumbra.set(0.46);
		spotLight1.p.castShadow.set(true);
		spotLight1.p.shadowRes.set([2048, 2048]);
		spotLight1.params.postCreateSpareParams();
		spotLight1.params.runOnSceneLoadHooks();
		return spotLight1;
	}
	function create_polarTransform1(parentNode: RootManagerNode) {
		var polarTransform1 = parentNode.createNode('polarTransform');
		polarTransform1.setName('polarTransform1');
		polarTransform1.uiData.setPosition(200, 50);
		polarTransform1.flags.display.set(false);
		polarTransform1.p.longitude.set(7.2);
		polarTransform1.p.latitude.set(36);
		polarTransform1.p.depth.set(10);
		polarTransform1.params.postCreateSpareParams();
		polarTransform1.params.runOnSceneLoadHooks();
		return polarTransform1;
	}
	var geo1 = create_geo1(root);
	var perspectiveCamera1 = create_perspectiveCamera1(root);
	create_geo2(root);
	var spotLight1 = create_spotLight1(root);
	var polarTransform1 = create_polarTransform1(root);
	spotLight1.setInput(0, polarTransform1);

	return {
		scene,
		cameraPath: perspectiveCamera1.path(),
		focusedNodes: [geo1.nodesByType('material')[0]],
		autoLayout: false,
	};
}
// export const matLineBasic = [
// 	new Example({
// 		name: `${ExamplePrefix.BY_NODE}/mat/lineBasic`,
// 		createData,
// 		relatedNodes: [LineBasicMatNode],
// 	}),
// ];
